import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ClipboardListIcon, BrainIcon } from 'lucide-react';
const bonuses = [{
  icon: <BookOpenIcon className="w-6 h-6 text-golden" data-id="element-10" />,
  title: 'Banco de Actividades de Motricidad Fina',
  description: 'Colección de actividades listas para aplicar en sesión para trabajar coordinación, precisión y destreza manual.'
}, {
  icon: <ClipboardListIcon className="w-6 h-6 text-golden" data-id="element-11" />,
  title: 'Kit Evaluación de Motricidad Fina',
  description: 'Fichas específicas para evaluar habilidades motoras en niños y adultos.'
}, {
  icon: <BrainIcon className="w-6 h-6 text-golden" data-id="element-12" />,
  title: 'Banco de Actividades de Estimulación Cognitiva',
  description: 'Actividades para memoria, atención y concentración.'
}];
export function BonusSection() {
  return <section id="bonos" className="py-10 px-4 bg-cream" data-id="element-13">
      <div className="max-w-xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 flex flex-col items-center" data-id="element-15">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-50 border border-red-100 text-red-500 text-sm font-bold tracking-wide uppercase mb-6" data-id="element-16">
            <span data-id="element-17">🎁</span> GRATIS POR EL DÍA DE HOY
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-olive-dark" data-id="element-18">
            Bonos Exclusivos
          </h2>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-19">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white/60 backdrop-blur-sm rounded-2xl p-5 border border-olive/10 flex items-start gap-5 shadow-sm" data-id="element-20">
              <div className="w-14 h-14 rounded-xl bg-olive/5 flex items-center justify-center shrink-0 border border-olive/5" data-id="element-21">
                {bonus.icon}
              </div>
              <div className="pt-1" data-id="element-22">
                <h3 className="text-lg font-bold text-olive-dark mb-1 font-serif leading-tight" data-id="element-23">
                  {bonus.title}
                </h3>
                <p className="text-olive/70 text-sm leading-relaxed" data-id="element-24">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-olive/10 text-center shadow-sm" data-id="element-25">
          <p className="text-olive/60 font-medium mb-2" data-id="element-26">
            Valor total de los 3 bonos:{' '}
            <span className="line-through decoration-olive/40" data-id="element-27">
              $42.000 ARS
            </span>
          </p>
          <div className="flex items-center justify-center gap-3 text-xl md:text-2xl font-bold text-golden" data-id="element-28">
            <span data-id="element-29">Por el día de hoy &rarr;</span>
            <span className="bg-warm-beige px-4 py-1 rounded-full text-golden border border-golden/20" data-id="element-30">
              GRATIS
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}